import React, { useState, useEffect } from 'react';
import { Typography, TextField, Grid, Button, Container, Card } from '@mui/material';
import styleForm from '../Tool/Style';
import { useStateValue } from '../../Contexto/store';
import DiccionarioEtiquetas from '../../Configuracion/Idiomas/Etiquetas_Diccionario';
import { enlistaArrayCodigosMensajesIdiomas } from '../../Actions/Generales/IdiomasAction';
import { withRouter } from 'react-router-dom';
import ImgLogin from '../../Activos/Imagenes/LogoClassLimitless.svg';
import { styleLogin } from '../Tool/Style';
import { useHistory } from "react-router-dom";
import { solicitarCambioContrasena } from '../../Actions/Usuarios/UsuarioAction';
import { LlavesConfiguraciones } from "../../Configuracion/Llaves/RepositorioConfig";

import { MostrarMensaje } from '../../Utilidades/ManejoMensajes';
import BackBtnIcon from '../ControlUsuario/Botones/BackBtnIcon';

const RecuperarContrasena = () => {

    const history = useHistory();

    //se accede al storage para ver la variable de sesion de usuario
    // contexto de variables globales con el Context Api 
    const [{ etiquetasIdioma }, dispatch] = useStateValue();

    const [email, SetEmail] = useState('');

    // Se declara la variable de estado que representa al idioma para las etiquetas del componente
    const [etiquetas, setEtiquetas] = useState({
        EtiquetasComponente: etiquetasIdioma ? etiquetasIdioma.EtiquetasComponente : DiccionarioEtiquetas.IdiomaDefault.Etiquetas,
        CodigoIdioma: etiquetasIdioma ? etiquetasIdioma.CodigoIdioma : DiccionarioEtiquetas.CodigoIdioma
    });

    useEffect(() => {
        // se llama al dispatch para que como tal se actualice el reducer
        setEtiquetas({
            EtiquetasComponente: etiquetasIdioma ? etiquetasIdioma.EtiquetasComponente : DiccionarioEtiquetas.IdiomaDefault.Etiquetas,
            CodigoIdioma: etiquetasIdioma ? etiquetasIdioma.CodigoIdioma : DiccionarioEtiquetas.CodigoIdioma
        });

    }, [etiquetasIdioma]);

    const regresarPaginaLogin = (e) => {
        e.preventDefault();
        history.push(LlavesConfiguraciones.rutaPublicacion + "/auth/login");
    }

    const recuperarPassword = async (e) => {
        e.preventDefault();
        dispatch({ type: "LOAD_COMP", texto: etiquetas.EtiquetasComponente.CargandoModal.Et_Procesando });
        const UrlRecuperacion = LlavesConfiguraciones.rutaPublicacionCompleta + '/auth/changePassword/';
        const responseUsuario = await solicitarCambioContrasena(email, UrlRecuperacion);
        if (responseUsuario?.status === 200) //si la respuesta fue existosa
        {
            dispatch({ type: "CLOSE_LOAD_COMP" });
            history.push({
                pathname: LlavesConfiguraciones.rutaPublicacion + '/auth/recoverySussed',
                state: { email: responseUsuario.data }
            });
        }
        else {
            dispatch({ type: "CLOSE_LOAD_COMP" });
            if (responseUsuario.data.errors) {
                const arrayErrores = enlistaArrayCodigosMensajesIdiomas(responseUsuario.data.errors);
                MostrarMensaje(dispatch, responseUsuario.data.typeError, arrayErrores);
            } else {
                MostrarMensaje(dispatch, 'error', [responseUsuario.statusText]);
            }
        }
    };

    return (
        <Container maxWidth="sm" justify="center" spacing={0} style={styleLogin.conteiner}>
           
            <Card style={styleLogin.divForm}>
               
               <BackBtnIcon
                    text={etiquetas.EtiquetasComponente.General.Et_tbnAtras} 
                />
               
               <div style={styleLogin.divContent}>

                <div style={{...styleForm.paper, marginTop:'0px'}}>
                    <img src={ImgLogin} alt={"Imagen de Registro"} />
                    <Typography variant="subtitle2" style={{ fontSize: 16, paddingTop: 25 }}>
                        {etiquetas.EtiquetasComponente.RecuperarContrasena.Et_TituloPrincipal}
                    </Typography>
                </div>
                <form style={styleForm.form}>
                    <Grid container spacing={2} style={{ backgroundColor: 'transparent' }}>
                        <Grid item xs={12} >
                            <Typography variant="body1" style={{ fontSize: 16, textAlign: 'justify' }}>
                                {etiquetas.EtiquetasComponente.RecuperarContrasena.Et_Cuerpo}
                            </Typography>
                        </Grid>
                        <Grid item xs={12} >
                            <TextField name="Email" variant="outlined" fullWidth label={etiquetas.EtiquetasComponente.RecuperarContrasena.Et_txtCorreo} value={email} onChange={(e) => SetEmail(e.target.value)} />
                        </Grid>
                        <Grid item xs={12} >
                            <Button fullWidth variant="contained" style={styleForm.submit} color="primary" size="large" onClick={recuperarPassword}>{etiquetas.EtiquetasComponente.RecuperarContrasena.Et_BotonAccion}</Button>
                        </Grid>
                       {/* <Grid item xs={12} >
                            <Button
                                fullWidth
                                variant="contained"
                                style={styleForm.submit}
                                size="large"
                                onClick={regresarPaginaLogin}>{etiquetas.EtiquetasComponente.RecuperarContrasena.Et_BotonRegresar}</Button>
                       </Grid> */}
                    </Grid>
                </form>
                </div>
            </Card>
        </Container>
    );
};

export default withRouter(RecuperarContrasena);